<template>
  <div class="section">
    <div class="container">
      <div class="level">
        <Header class="level-left" v-bind="$route.meta" />
        <b-button
          class="left-right"
          type="is-success"
          icon-left="plus"
          @click="showCreateForm()"
        >
          New Forecast
        </b-button>
      </div>
      <div class="columns">
        <div class="column">
          <b-field grouped>
            <b-field :label="$t('pages.customer_forecast.continent')">
              <multiselect
                v-model="continentFilter"
                :options="continents"
                :multiple="true"
                placeholder="Continent"
                style="min-width: 400px;"
                @select="continentSelected()"
                @remove="continentRemoved()"
              />
            </b-field>
          </b-field>
          <b-field grouped>
            <b-field :label="$t('pages.customer_forecast.country')">
              <multiselect
                v-model="countryFilter"
                :options="filteredCountries"
                :multiple="true"
                placeholder="Country"
                style="min-width: 400px;"
                :custom-label="(obj) => obj.name"
                track-by="code"
                @select="countrySelected()"
                @remove="countryRemoved()"
              />
            </b-field>
          </b-field>
          <b-field grouped>
            <b-field :label="$t('pages.customer_forecast.sold_to_filter')">
              <multiselect
                v-model="sold_to_filter"
                :options="sold_to_filter_options"
                :multiple="true"
                placeholder="Sold To"
                style="min-width: 400px;"
                :custom-label="(obj) => obj.sold_to + ' - ' + obj.sold_to_name"
                track-by="sold_to"
                @select="soldToFilterSelected()"
                @remove="soldToFilterRemoved()"
              />
            </b-field>
          </b-field>
          <b-field>
            <b-button
              class="left-right"
              type="is-warning"
              icon-left="arrows-rotate"
              :disabled="isLoading"
              @click="() => {resetData(); getData();}"
            >
              Load
            </b-button>
            <b-button
              class="ml-3"
              type="is-success"
              icon-left="upload"
              @click="() => {isImportingExcel = true}"
            >
              Import xlsx
            </b-button>
          </b-field>
          <ag-grid-vue
            v-if="forecasts.length != 0"
            style="width: 100%; height: 700px;"
            class="ag-theme-balham"
            :row-data="forecasts"
            :grid-options="gridOptions"
            :pagination="true"
            :pagination-auto-page-size="true"
            :cache-overflow-size="0"
            :multi-sort-key="'ctrl'"
            :modules="modules"
            :get-context-menu-items="getContextMenuItems"
          />
        </div>
      </div>
    </div>
    <b-modal :active.sync="isCreatingForecast" scroll="keep" has-modal-card>
      <form v-if="isCreatingForecast" @submit.prevent="submitForecast">
        <div class="modal-card" style="min-width: 50vw; width: fit-content; min-height: 50vh; height: fit-content;">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Create Forecast
            </p>
          </header>
          <section class="modal-card-body">
            <b-field grouped>
              <b-field :label="$t('pages.customer_forecast.delivery_date')">
                <b-datepicker
                  v-model="newForecast.delivery_date"
                  name="newdeliverydate"
                  :first-day-of-week="1"
                  :locale="'en-CA'"
                  icon="calendar-alt"
                />
              </b-field>
              <b-field :label="$t('pages.customer_forecast.reception_date')">
                <b-datepicker
                  v-model="newForecast.reception_date"
                  name="newreceptiondate"
                  :first-day-of-week="1"
                  :locale="'en-CA'"
                  icon="calendar-alt"
                />
              </b-field>
            </b-field>
            <b-field>
              <b-button
                :type="goingShipTo ? 'is-success' : ''"
                :disabled="!soldToSelected"
                @click="chooseStart('SHIP')"
              >
                {{ $t('pages.customer_forecast.add_ship_to') }}
              </b-button>
              <b-button
                :type="goingPort ? 'is-success' : ''"
                @click="chooseStart('PORT')"
              >
                {{ $t('pages.customer_forecast.add_port') }}
              </b-button>
            </b-field>
            <b-field label="Sold To">
              <multiselect
                v-model="newForecast.sold_to_object"
                :options="soldTos"
                :multiple="false"
                :close-on-select="true"
                placeholder="Pick customer"
                :custom-label="(obj) => obj.sold_to + ' - ' + obj.sold_to_name"
                track-by="sold_to"
                style="min-width: 400px;"
                @select="() => { soldToSelected = true }"
              />
            </b-field>
            <div v-if="soldToSelected">
              <!-- <b-field :label="$t('pages.customer_forecast.sold_to')">
                {{ newForecast.sold_to_object.sold_to }}
              </b-field>
              <b-field :label="$t('pages.customer_forecast.sold_to_name')">
                {{ newForecast.sold_to_object.sold_to_name }}
              </b-field> -->
              <b-field v-if="newForecast.sold_to_object.sold_to_alt && newForecast.sold_to_object.sold_to_alt != ''" :label="$t('pages.customer_forecast.sold_to_alt')">
                {{ newForecast.sold_to_object.sold_to_alt }}
              </b-field>
            </div>
            <div v-if="goingShipTo">
              <b-field label="Ship To">
                <multiselect
                  v-model="newForecast.ship_to_object"
                  :options="shipTos"
                  :multiple="false"
                  :close-on-select="true"
                  placeholder="Pick Ship To"
                  :custom-label="(obj) => obj.ship_to + ' - ' + obj.ship_to_name"
                  track-by="ship_to"
                  style="min-width: 400px;"
                  @select="() => { shipToSelected = true }"
                />
              </b-field>
              <div v-if="shipToSelected">
                <!-- <b-field :label="$t('pages.customer_forecast.sold_to')">
                  {{ newForecast.sold_to_object.sold_to }}
                </b-field>
                <b-field :label="$t('pages.customer_forecast.sold_to_name')">
                  {{ newForecast.sold_to_object.sold_to_name }}
                </b-field> -->
                <b-field v-if="newForecast.ship_to_object.ship_to_alt && newForecast.ship_to_object.ship_to_alt != ''" :label="$t('pages.customer_forecast.ship_to_alt')">
                  {{ newForecast.ship_to_object.ship_to_alt }}
                </b-field>
                <!-- <b-field v-if="newForecast.ship_to_object.ship_to_country && newForecast.ship_to_object.ship_to_country != ''" :label="$t('pages.customer_forecast.ship_to_region')">
                  {{ newForecast.ship_to_object.ship_to_country }}
                </b-field> -->
              </div>
              <!-- <b-field :label="$t('pages.customer_forecast.ship_to')">
                <b-input v-model="newForecast.ship_to" type="text" />
              </b-field>
              <b-field :label="$t('pages.customer_forecast.ship_to_name')">
                <b-input v-model="newForecast.ship_to_name" type="text" />
              </b-field>
              <b-field :label="$t('pages.customer_forecast.ship_to_alt')">
                <b-input v-model="newForecast.ship_to_alt" type="text" />
              </b-field>
              <b-field :label="$t('pages.customer_forecast.ship_to_region')">
                <b-select v-model="newForecast.ship_to_region">
                  <option value="USA">
                    USA
                  </option>
                  <option value="CA">
                    Canada
                  </option>
                  <option value="BR">
                    Brazil
                  </option>
                  <option value="DE">
                    Germany
                  </option>
                </b-select>
              </b-field> -->
            </div>
            <div v-if="goingPort">
              <b-field label="Port">
                <multiselect
                  v-model="newForecast.port"
                  :options="ports"
                  :multiple="false"
                  :close-on-select="true"
                  placeholder="Pick Port"
                  :custom-label="(obj) => obj.name"
                  track-by="name"
                  style="min-width: 400px;"
                />
              </b-field>
            </div>
            <b-field :label="$t('pages.customer_forecast.quantity')">
              <b-input v-model="newForecast.quantity" type="number" />
            </b-field>
            <b-field :label="$t('pages.customer_forecast.material')">
              <b-select v-model="newForecast.material">
                <option value="5.2">
                  5.2
                </option>
                <option value="5.5">
                  5.5
                </option>
                <option value="5.1">
                  5.1
                </option>
                <option value="1">
                  1
                </option>
              </b-select>
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <button type="submit" class="button is-info is-fullwidth">
              {{ $t('global.submit') }}
            </button>
          </footer>
        </div>
      </form>
    </b-modal>
    <b-modal :active.sync="isImportingExcel" scroll="keep" has-modal-card>
      <div v-if="isImportingExcel" style="margin-left: -20vw;">
        <div class="modal-card" style="min-width: 70vw; width: fit-content; min-height: 50vh; height: fit-content;">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Import Excel Simulations
            </p>
          </header>
          <section class="modal-card-body">
            <b-field grouped>
              <b-field>
                <input
                  id="fileUpload"
                  type="file"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  hidden
                  @change="loadFile"
                >
                <b-button class="btn" @click="chooseFiles">
                  Choose File
                </b-button>
              </b-field>
              <b-field>
                <b-button
                  class="left-right"
                  type="is-warning"
                  icon-left="x"
                  :disabled="!loadedExcel"
                  @click="() => {testExcel()}"
                >
                  Read Simulations
                </b-button>
              </b-field>
              <b-field>
                <b-button
                  class="left-right"
                  type="is-warning"
                  icon-left="x"
                  :disabled="importedForecasts.length <= 0"
                  @click="() => {saveForecasts()}"
                >
                  Save Forecasts
                </b-button>
              </b-field>
            </b-field>
            <div v-if="importedForecasts && importedForecasts.length > 0" style="margin-top: 5px; margin-bottom: 20px; overflow-x: auto;">
              <table class="table is-striped is-bordered is-narrow is-fullwidth">
                <thead>
                  <tr>
                    <th>Sold To Name</th>
                    <th>Ship To Name</th>
                    <th>Material</th>
                    <th>Quantity</th>
                    <th>Port</th>
                    <th>Delivery Date</th>
                    <th>Reception Date</th>
                    <th>Sold To Alt</th>
                    <th>Ship To Region</th>
                    <th>Sold To</th>
                    <th>Ship To</th>
                    <th>Ship To Alt</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(importedForecast, index) in importedForecasts" :key="'simulation' + index">
                    <td>{{ importedForecast.sold_to_name }}</td>
                    <td>{{ importedForecast.ship_to_name }}</td>
                    <td>{{ importedForecast.material }}</td>
                    <td>{{ importedForecast.quantity }}</td>
                    <td>{{ importedForecast.port }}</td>
                    <td>{{ new Date(importedForecast.delivery_date).toLocaleDateString('en-CA') }}</td>
                    <td>{{ new Date(importedForecast.reception_date).toLocaleDateString('en-CA') }}</td>
                    <td>{{ importedForecast.sold_to_alt }}</td>
                    <td>{{ importedForecast.ship_to_region }}</td>
                    <td>{{ importedForecast.sold_to }}</td>
                    <td>{{ importedForecast.ship_to }}</td>
                    <td>{{ importedForecast.ship_to_alt }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { AllModules } from '@ag-grid-enterprise/all-modules'
import { mapState } from 'vuex'
import clientForecast from '../../../../services/v3/clientForecast'
import { countries } from './countries'
import exceljs from 'exceljs'
// import sortAndFilterMixins from '@/mixins/agGridSortAndFilter'

export default {
  name: 'ClientForecast',
  components: {
  },
  data: function () {
    return {
      newForecast: null,
      isLoading: false,
      countryFilter: null,
      countries,
      continentFilter: null,
      isImportingExcel: false,
      continents: [
        'Africa',
        'Asia',
        'North America',
        'Europe',
        'Oceania',
        'South America'
      ],
      ports: [
        {
          name: 'ABIDJAN',
          country: 'CI'
        },
        {
          name: 'BELAWAN',
          country: 'ID'
        },
        {
          name: 'LAEM CHABANG',
          country: 'TH'
        },
        {
          name: 'PADANG',
          country: 'ID'
        },
        {
          name: 'PALEMBANG',
          country: 'ID'
        },
        {
          name: 'PONTIANAK',
          country: 'ID'
        },
        {
          name: 'PORT KLANG',
          country: 'MY'
        },
        {
          name: 'PUERTO QUETZAL',
          country: 'GT'
        },
        {
          name: 'SAN PEDRO',
          country: 'CI'
        },
        {
          name: 'SGP_MY',
          country: 'SG'
        },
        {
          name: 'SONGKHLA',
          country: 'TH'
        },
        {
          name: 'SURABAYA',
          country: 'ID'
        },
        {
          name: 'DOUALA',
          country: 'CM'
        },
        {
          name: 'MONROVIA',
          country: 'LR'
        }
      ],
      allShipTos: [],
      ship_tos_loaded: null,
      shipTos: [],
      soldTosLoaded: false,
      soldToSelected: false,
      shipToSelected: false,
      soldTos: [],
      sold_to_filter_options: [],
      sold_to_filter: [],
      importedForecasts: [],
      loadedExcel: false,
      goingShipTo: false,
      goingPort: false,
      region: null,
      start: null,
      end: new Date(),
      isCreatingForecast: false,
      forecasts: [],
      modules: AllModules,
      gridOptions: {
        cacheBlockSize: 20,
        paginationPageSize: 20,
        enableRangeSelection: true,
        defaultColDef: {
          floatingFilter: true,
          enableValue: true,
          enableRowGroup: true,
          enablePivot: false,
          resizable: true
        },
        columnDefs: [
          { headerName: this.$t('pages.customer_forecast.sold_to_name'),
            field: 'sold_to_name',
            filter: 'agTextColumnFilter',
            width: 160,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          },
          { headerName: this.$t('pages.customer_forecast.ship_to_name'),
            field: 'ship_to_name',
            filter: 'agTextColumnFilter',
            width: 160,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          },
          { headerName: this.$t('pages.customer_forecast.delivery_date'),
            field: 'delivery_date',
            filter: 'agTextColumnFilter',
            width: 100,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          },
          { headerName: this.$t('pages.customer_forecast.quantity'),
            field: 'quantity',
            filter: 'agTextColumnFilter',
            width: 100,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          },
          { headerName: this.$t('pages.customer_forecast.material'),
            field: 'material',
            filter: 'agTextColumnFilter',
            width: 100,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          },
          { headerName: this.$t('pages.customer_forecast.reception_date'),
            field: 'reception_date',
            filter: 'agTextColumnFilter',
            width: 100,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          },
          { headerName: this.$t('pages.customer_forecast.ship_to_region'),
            field: 'ship_to_region',
            filter: 'agTextColumnFilter',
            width: 120,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          }// ,
          // { headerName: this.$t('pages.customer_forecast.sold_to'),
          //   field: 'sold_to',
          //   filter: 'agTextColumnFilter',
          //   width: 160,
          //   sortable: true,
          //   filterParams: { suppressAndOrCondition: true }
          // },
          // { headerName: this.$t('pages.customer_forecast.ship_to'),
          //   field: 'ship_to',
          //   filter: 'agTextColumnFilter',
          //   width: 160,
          //   sortable: true,
          //   filterParams: { suppressAndOrCondition: true }
          // },
          // { headerName: this.$t('pages.customer_forecast.port'),
          //   field: 'port',
          //   filter: 'agTextColumnFilter',
          //   width: 160,
          //   sortable: true,
          //   filterParams: { suppressAndOrCondition: true }
          // },
          // { headerName: this.$t('pages.customer_forecast.sold_to_alt'),
          //   field: 'sold_to_alt',
          //   filter: 'agTextColumnFilter',
          //   width: 160,
          //   sortable: true,
          //   filterParams: { suppressAndOrCondition: true }
          // },
          // { headerName: this.$t('pages.customer_forecast.ship_to_alt'),
          //   field: 'ship_to_alt',
          //   filter: 'agTextColumnFilter',
          //   width: 160,
          //   sortable: true,
          //   filterParams: { suppressAndOrCondition: true }
          // }
        ],
        sideBar: {
          toolPanels: [
            {
              id: 'columns',
              labelDefault: 'Columns',
              labelKey: 'columns',
              iconKey: 'columns',
              toolPanel: 'agColumnsToolPanel',
              toolPanelParams: {
                // tool panel columns won't move when columns are reordered in the grid
                suppressSyncLayoutWithGrid: true,
                // prevents columns being reordered from the Columns Tool Panel
                suppressColumnMove: true
              }
            }
          ],
          defaultToolPanel: ''
        }
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    filteredCountries () {
      if (!this.continentFilter || this.continentFilter.length === 0) {
        return this.countries
      }
      return this.countries.filter(c => this.continentFilter.includes(c.continent))
    }
  },
  mounted: async function () {
    this.start = new Date()
    this.start.setDate(new Date().getDate() - 365)
    this.soldTos = await clientForecast.getSoldTos()
    this.allShipTos = await clientForecast.getAllShipTos()
    this.sold_to_filter_options = this.soldTos
    this.soldTosLoaded = true
  },
  methods: {
    resetData () {
      this.forecasts = []
      this.goingShipTo = false
      this.goingPort = false
      this.soldToSelected = false
      this.shipToSelected = false
      this.ship_tos_loaded = null
      this.shipTos = []
      this.allShipTos = []
    },
    async continentSelected () {
      this.pruneCountryFilter()
    },
    async countrySelected () {
      this.sold_to_filter_options = this.soldTos.filter(x => {
        return this.countryFilter.map(c => c.code).includes(x.sold_to_country)
      })
    },
    async soldToFilterSelected () {
    },
    async continentRemoved () {
      this.pruneCountryFilter()
    },
    pruneCountryFilter () {
      // Drop any selected country that is no longer part of the filtered options
      if (this.countryFilter && this.countryFilter.length > 0) {
        const allowedCodes = this.filteredCountries.map(c => c.code)
        this.countryFilter = this.countryFilter.filter(c => allowedCodes.includes(c.code))
        this.countryRemoved()
      }
    },
    async countryRemoved () {
      if (!this.countryFilter || this.countryFilter.length === 0) {
        this.sold_to_filter_options = this.soldTos
      } else {
        this.sold_to_filter_options = this.soldTos.filter(x => {
          return this.countryFilter.map(c => c.code).includes(x.sold_to_country)
        })
      }
    },
    async soldToFilterRemoved () {
    },
    async chooseStart (start) {
      if (start === 'PORT') {
        this.goingPort = true
        this.goingShipTo = false
      } else if (start === 'SHIP') {
        this.goingPort = false
        if (this.ship_tos_loaded !== this.newForecast.sold_to_object.sold_to) {
          try {
            this.shipTos = await clientForecast.getShipTos(this.newForecast.sold_to_object.sold_to)
            this.ship_tos_loaded = this.newForecast.sold_to_object.sold_to
          } catch (e) {
            this.$buefy.toast.open({ message: e.message, duration: 3000, type: 'is-danger' })
          }
        }
        this.goingShipTo = true
      }
    },
    showCreateForm () {
      this.isCreatingForecast = true
      this.newForecast = {
        quantity: 0,
        material: '',
        delivery_date: new Date(new Date().toLocaleDateString('en-CA')),
        reception_date: new Date(new Date().toLocaleDateString('en-CA')),
        ship_to_region: '',
        sold_to: '',
        ship_to: '',
        sold_to_name: '',
        ship_to_name: '',
        port: '',
        sold_to_alt: '',
        ship_to_alt: '',
        sold_to_object: null,
        ship_to_object: null
      }
    },
    async getData () {
      this.isLoading = true
      try {
        const data = await clientForecast.getTable({
          continent: this.continentFilter && this.continentFilter.length > 0 ? this.continentFilter : null,
          country: this.countryFilter && this.countryFilter.length > 0 ? this.countryFilter.map(c => c.code) : null,
          soldto: this.sold_to_filter && this.sold_to_filter.length > 0 ? this.sold_to_filter.map(x => x.sold_to) : null
        })
        data.forEach(element => {
          this.forecasts.push({
            id: element.id,
            quantity: element.quantity,
            material: element.material,
            delivery_date: element.delivery_date ? new Date(element.delivery_date.split('Z')[0]).toLocaleDateString('en-CA') : null,
            reception_date: element.reception_date ? new Date(element.reception_date.split('Z')[0]).toLocaleDateString('en-CA') : null,
            ship_to_region: element.ship_to_region,
            sold_to: element.sold_to,
            ship_to: element.ship_to,
            sold_to_name: element.sold_to_name,
            ship_to_name: element.ship_to_name,
            port: element.port,
            sold_to_alt: element.sold_to_alt,
            ship_to_alt: element.ship_to_alt
          })
        })
        if (this.forecasts.length > 0) {
          this.$buefy.toast.open({ message: 'Data loaded', duration: 3000, type: 'is-success' })
        } else {
          this.$buefy.toast.open({ message: 'No corresponding Forecasts found', duration: 3000, type: 'is-danger' })
        }
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
        this.isLoading = false
      }
      this.isLoading = false
    },
    getContextMenuItems (params) {
      const selectedForecast = {
        id: params.node.data.id,
        quantity: params.node.data.quantity,
        material: params.node.data.material,
        delivery_date: params.node.data.delivery_date,
        reception_date: params.node.data.reception_date,
        ship_to_region: params.node.data.ship_to_region,
        sold_to: params.node.data.sold_to,
        ship_to: params.node.data.ship_to,
        sold_to_name: params.node.data.sold_to_name,
        ship_to_name: params.node.data.ship_to_name,
        port: params.node.data.port,
        sold_to_alt: params.node.data.sold_to_alt,
        ship_to_alt: params.node.data.ship_to_alt
      }
      let customMenu = []
      const genericMenu = [
        'separator',
        'copy',
        'copyWithHeaders',
        'separator',
        'export'
      ]
      customMenu.push({
        name: 'Delete Forecast',
        action: () => {
          this.deleteForecast(selectedForecast)
        },
        icon: '<i class="fas fa-fw fa-xmark" ></i>'
      })
      const result = [...customMenu, ...genericMenu]
      return result
    },
    chooseFiles: function () {
      document.getElementById('fileUpload').click()
    },
    async saveForecasts () {
      this.isLoading = true
      this.$buefy.toast.open({ message: 'Saving Forecasts', duration: 10000, type: 'is-success' })
      if (this.importedForecasts && this.importedForecasts.length > 0) {
        await clientForecast.createForecastArray(this.importedForecasts)
      }
      this.resetData()
      this.getData()
      this.isImportingExcel = false
      this.isLoading = false
    },
    async loadFile (file) {
      this.file = file.target.files[0]
      const reader = new FileReader()

      reader.onload = (event) => {
        this.fileBuffer = event.target.result
      }
      await reader.readAsArrayBuffer(this.file)
      this.loadedExcel = true
    },
    async testExcel () {
      this.$buefy.toast.open({ message: 'Reading data, this could take a moment.', duration: 3000, type: 'is-success' })
      var readWb = new exceljs.Workbook()
      await readWb.xlsx.load(this.fileBuffer)
      var forecastSheet = readWb.getWorksheet('FORECAST')
      var index = 3
      this.importedForecasts = []
      var customerName = forecastSheet.getCell('A3').value
      while (customerName && customerName.length > 0) {
        this.importedForecasts.push({
          sold_to_name: customerName,
          sold_to: forecastSheet.getCell('K' + index).result,
          ship_to_region: forecastSheet.getCell('J' + index).result,
          ship_to: forecastSheet.getCell('L' + index).result,
          reception_date: forecastSheet.getCell('I' + index).value,
          delivery_date: forecastSheet.getCell('H' + index).value,
          material: forecastSheet.getCell('G' + index).value,
          quantity: forecastSheet.getCell('F' + index).value,
          port: forecastSheet.getCell('E' + index).value,
          ship_to_alt: forecastSheet.getCell('D' + index).value,
          sold_to_alt: forecastSheet.getCell('C' + index).value,
          ship_to_name: forecastSheet.getCell('B' + index).value && forecastSheet.getCell('B' + index).value.length > 0 ? forecastSheet.getCell('B' + index).value : forecastSheet.getCell('E' + index).value
        })
        index += 1
        customerName = forecastSheet.getCell('A' + index).value
      }
      this.$buefy.toast.open({ message: 'Data loaded, please check that the import looks good before submitting.', duration: 3000, type: 'is-success' })
    },
    submitForecast () {
      if (!this.newForecast.sold_to_object) {
        this.$buefy.toast.open({ message: 'Please select a sold to', duration: 3000, type: 'is-danger' })
        return
      }
      if (!this.goingShipTo && !this.goingPort) {
        this.$buefy.toast.open({ message: 'Please select a port or ship to', duration: 3000, type: 'is-danger' })
        return
      }
      if (this.goingPort && !this.newForecast.port) {
        this.$buefy.toast.open({ message: 'Please select a port or ship to', duration: 3000, type: 'is-danger' })
        return
      }
      if (this.goingShipTo && !this.newForecast.ship_to_object) {
        this.$buefy.toast.open({ message: 'Please select a port or ship to', duration: 3000, type: 'is-danger' })
        return
      }
      if (!this.newForecast.material && !this.newForecast.quantity) {
        this.$buefy.toast.open({ message: 'Please select a material and a quantity', duration: 3000, type: 'is-danger' })
        return
      }
      this.isCreatingForecast = false
      try {
        clientForecast.createForecast(
          {
            id: this.newForecast.id,
            quantity: this.newForecast.quantity,
            material: this.newForecast.material,
            delivery_date: this.newForecast.delivery_date,
            reception_date: this.newForecast.reception_date,
            ship_to_region: this.goingShipTo ? this.newForecast.ship_to_object.ship_to_country : this.goingPort ? this.newForecast.port.country : null,
            sold_to: this.newForecast.sold_to_object.sold_to,
            ship_to: this.goingShipTo ? this.newForecast.ship_to_object.ship_to : this.goingPort ? this.newForecast.port.name : null,
            sold_to_name: this.newForecast.sold_to_object.sold_to_name,
            ship_to_name: this.goingShipTo ? this.newForecast.ship_to_object.ship_to_name : this.goingPort ? this.newForecast.port && this.newForecast.port.name ? this.newForecast.port.name : null : null,
            port: this.newForecast.port && this.newForecast.port.name ? this.newForecast.port.name : null,
            sold_to_alt: this.newForecast.sold_to_alt,
            ship_to_alt: this.newForecast.ship_to_alt
          }).then(() => {
          this.$buefy.toast.open({ message: 'Forecast Created', duration: 3000, type: 'is-success' })
          this.resetData()
          this.getData()
        })
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
      }
    },
    async deleteForecast (forecast) {
      try {
        await clientForecast.archiveForecast(forecast.id)
        this.$buefy.toast.open({ message: 'Forecast Deleted', duration: 3000, type: 'is-warning' })
        this.resetData()
        this.getData()
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
      }
    }
  }
}

</script>
